"use client";

import Script from "next/script";
import React from "react";

export const GoogleTranslate = () => {
  return (
    <>
      {/* Google Translate Container (Off-screen) */}
      <div
        id="google_translate_element"
        style={{
          position: "fixed",
          top: "-100px",
          left: "-100px",
          opacity: 0,
          pointerEvents: "none",
          zIndex: -1,
        }}
      />

      <Script id="google-translate-config" strategy="afterInteractive">
        {`
          window.googleTranslateElementInit = function() {
            new google.translate.TranslateElement({
              pageLanguage: 'en',
              includedLanguages: 'en,hi,ta,gu',
              layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
              autoDisplay: false
            }, 'google_translate_element');
          };
        `}
      </Script>
      <Script
        src="https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
        strategy="afterInteractive"
      />
    </>
  );
};
